function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
import Loader from 'svg/loader.svg';
import urlRouteShape from 'shapes/urlRouteShape';
import Account from 'modules/Account';
import { AlertsBus } from 'modules/App';
import history from 'helpers/history';
import styles from './ClinicSetup.pcss';
var _React_PureComponent;
class ClinicSetup extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        this.props.onValidateMemberships();
    }
    componentDidUpdate(prevProps) {
        const { activeProfileMainUrlRoute, isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            const { name, params } = activeProfileMainUrlRoute;
            const url = this.context.getUrl(name, params);
            history.push(url);
        }
    }
    renderLoader() {
        if (this.props.hasErrors) {
            return 'Has errors';
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.loaderContainer,
            children: /*#__PURE__*/ _jsx(Loader, {
                className: cn(styles.loader, 'rotatingLoader')
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "pageHeader",
                    children: /*#__PURE__*/ _jsx("h1", {
                        className: "text--h1",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.headers.configuringClinic))
                    })
                }),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-5"
                }),
                this.renderLoader()
            ]
        });
    }
}
_define_property(ClinicSetup, "contextType", AppContext);
_define_property(ClinicSetup, "propTypes", {
    // Explicit props
    activeProfileType: Account.shapes.profileType,
    // Implicit props
    isInProgress: PropTypes.bool,
    hcpProfile: PropTypes.object,
    activeProfileMainUrlRoute: urlRouteShape,
    hasErrors: PropTypes.bool,
    // Implicit actions
    onValidateMemberships: PropTypes.func
});
const mapStateToProps = (state)=>({
        activeProfileMainUrlRoute: Account.selectors.activeProfileMainUrlRoute(state),
        isInProgress: Account.selectors.isValidateMembershipInProgress(state),
        hasErrors: Account.selectors.hasValidateMembershipErrors(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onValidateMemberships: ()=>dispatch(Account.actions.validateMemberships())
    });
const ConnectedClinicSetup = connect(mapStateToProps, mapDispatchToProps)(ClinicSetup);
export default withStyles(styles)(ConnectedClinicSetup);
